export default __webpack_public_path__ + "static/media/virtual-tour-slide-2-mobile.106ded72.png";